const STATES = [
  { id: "draft", name: "draft" },
  { id: "loaded", name: "loaded" },
  { id: "deleted", name: "deleted" },
  { id: "done", name: "done" },
];

function ChargeButton(_, record) {
  return record.state === "loaded";
}

function layout() {
  const ctxView = {
    model: "hotel.service.line",
    domain: [],
    form_action: [],
    table_action: [],
    target: "service",

    fields: {
      folio: {
        type: "many2one",
        model: "hotel.folio",
        required: true,
      },

      room: {
        type: "many2one",
        model: "hotel.room",
        required: true,
      },

      guest: {
        type: "char",
      },

      product: {
        type: "many2one",
        model: "product.product",
        required: true,
      },

      quantity: {
        type: "integer",
        required: true,
        default: 1,
      },

      description: {
        type: "char",
      },

      order: {
        type: "char",
        readOnly: true,
      },

      unit_price_w_tax: {
        type: "numeric",
        digits: [16, 2],
        required: true,
      },

      stock_move: {
        type: "many2one",
        model: "stock.move",
        readOnly: true,
      },

      analytic_account: {
        type: "many2one",
        model: "analytic_account.account",
        readOnly: true,
      },
      storage: {
        type: "many2one",
        model: "stock.location",
        readOnly: true,
      },
      charge_button: {
        type: "button",
        button_method: "load",
        color: "sky",
        invisible: ChargeButton,
      },

      state: {
        type: "char",
        tags: STATES,
        translate: true,
        readOnly: true,
      },
    },

    list: [
      { name: "room" },
      { name: "guest" },
      { name: "quantity" },
      { name: "state" },
      { name: "charge_button" },
    ],

    form: [
      { name: "folio" },
      { name: "room" },
      { name: "guest" },
      { name: "product" },
      { name: "charge_button" },
      { name: "quantity" },
      { name: "unit_price_w_tax" },
      { name: "state" },
    ],
  };

  return ctxView;
}

export { layout };
